import { isLocalhost } from './isLocalhost'

const checksTestEnvironment = () => {
  if (isLocalhost) return true

  return window.location.origin.includes('aztest')
}

// returns true if testenvironment (for most testenvironments, not bulletproof), removes 'prodtest'
export const isTestEnvironment = checksTestEnvironment()
